<template>
	<div class="loading">
        <div>
    		<img src="@/assets/img/nudgd.png">

            <h2 v-if="$store.state.errorMessage">{{ $store.state.errorMessage }}</h2>
        </div>
	</div>
</template>

<script>
export default {
    name: 'Loading',
    props: [],

    data() {
    	return {
			
    	}
    },

    methods: {
    	
    },

    computed: {
    	
    }
}
</script>